export default __webpack_public_path__ + "static/media/catalyst.e06d6439.svg";